import React from 'react';
import {Popover, PopoverTitle, PopoverContent } from 'reactstrap';

const pSize = {
  maxWidth: '350px'
}

export default class PopoverHelper extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popoverOpen: false
    }

    this.toggle = this.toggle.bind(this);
  }

  toggle(e) {
    // e.preventDefault();
    this.setState({
      popoverOpen: !this.state.popoverOpen
    })
  }

  componentWillUnmount() {
    clearTimeout(this.interval)
  }

  render() {
    const {id, title, content, contentNewLine, iconSize, placement, mLeft} = this.props;

    return (
      <span style={{'marginLeft': mLeft}}>
        <i 
          id={id} 
          onClick={this.toggle}
          role="button" 
          className="icon-question" 
          style={{'fontSize': iconSize}}
        />
        <Popover onClick={this.toggle} onMouseOut={this.toggle} placement={placement} isOpen={this.state.popoverOpen} target={id}>
          {title !== '' ? <PopoverTitle>{title}</PopoverTitle> : null }
          <PopoverContent style={pSize}>
            <p style={{whiteSpace: 'pre-line'}}>{content}</p>
            <span>{contentNewLine === '' ? null : contentNewLine }</span>
          </PopoverContent>
        </Popover>
      </span>
    );
  }
}
  
PopoverHelper.defaultProps = {
  placement: 'bottom',
  mLeft    : '.5rem'
};


// WEBPACK FOOTER //
// ./src/App/utils/PopoverHelper.js